/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Port } from './Port';
import {
    PortFromJSON,
    PortFromJSONTyped,
    PortToJSON,
} from './Port';

/**
 * Identification of port and arrival "ata" and departure "atd" time
 * @export
 * @interface PortHistorical
 */
export interface PortHistorical {
    /**
     * Actual Time of Arrival [UTC]
     * @type {string}
     * @memberof PortHistorical
     */
    ata?: string;
    /**
     * Actual Time of Departure [UTC]
     * @type {string}
     * @memberof PortHistorical
     */
    atd?: string;
    /**
     * 
     * @type {Port}
     * @memberof PortHistorical
     */
    port?: Port;
}

/**
 * Check if a given object implements the PortHistorical interface.
 */
export function instanceOfPortHistorical(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortHistoricalFromJSON(json: any): PortHistorical {
    return PortHistoricalFromJSONTyped(json, false);
}

export function PortHistoricalFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortHistorical {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ata': !exists(json, 'ata') ? undefined : json['ata'],
        'atd': !exists(json, 'atd') ? undefined : json['atd'],
        'port': !exists(json, 'port') ? undefined : PortFromJSON(json['port']),
    };
}

export function PortHistoricalToJSON(value?: PortHistorical | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ata': value.ata,
        'atd': value.atd,
        'port': PortToJSON(value.port),
    };
}

